import { useStore } from '@/infra/store';
import { WORLD_PIXEL_W, WORLD_PIXEL_H } from '@/domain/world/types';
import { COLORS, RADIUS } from '@/presentation/theme/tokens';

const W = 120;
const H = 90;

const BIOME_COLORS: Record<string, string> = {
  meadow: '#6cae5e',
  forest: '#3a6e3a',
  cave: '#4a4658',
  coast: '#f2d8a6',
};

export function Minimap() {
  const playerX = useStore((s) => s.playerX);
  const playerY = useStore((s) => s.playerY);
  const items = useStore((s) => s.world.regionItems);

  const sx = (x: number): number => (x / WORLD_PIXEL_W) * W;
  const sy = (y: number): number => (y / WORLD_PIXEL_H) * H;

  return (
    <div data-testid="minimap" style={wrap}>
      <svg width={W} height={H} viewBox={`0 0 ${W} ${H}`}>
        <rect x={0} y={0} width={W / 2} height={H / 2} fill={BIOME_COLORS.meadow} />
        <rect x={W / 2} y={0} width={W / 2} height={H / 2} fill={BIOME_COLORS.forest} />
        <rect x={0} y={H / 2} width={W / 2} height={H / 2} fill={BIOME_COLORS.cave} />
        <rect x={W / 2} y={H / 2} width={W / 2} height={H / 2} fill={BIOME_COLORS.coast} />
        {/* items dots */}
        {Object.entries(items).map(([_b, list]) =>
          list
            .filter((it) => !it.collected)
            .map((it) => (
              <circle
                key={it.id}
                cx={sx(it.x)}
                cy={sy(it.y)}
                r={1.2}
                fill="#ffe066"
              />
            )),
        )}
        {/* player */}
        <circle cx={sx(playerX)} cy={sy(playerY)} r={2.5} fill="#ff6e6e" stroke="#fff" strokeWidth={0.5}>
          <animate attributeName="r" values="2.5;3.5;2.5" dur="0.9s" repeatCount="indefinite" />
        </circle>
      </svg>
    </div>
  );
}

const wrap: React.CSSProperties = {
  background: COLORS.surfaceSoft,
  borderRadius: RADIUS.md,
  border: `1px solid ${COLORS.border}`,
  padding: 4,
  backdropFilter: 'blur(4px)',
};
